import { IGeneralNote, IGeneralNoteData,ITableRes } from 'types'

import { baseApi } from './baseApi'

export const GeneralNotesAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_generalNotes: builder.query<ITableRes<IGeneralNote>, {assignment_id: string, params?: any}>({
      query: ({assignment_id, params={}}) => ({
        url: `/assignment-all-purpose-items/${assignment_id}/`,
        params,
      }),
      providesTags: ['general-notes'],
    }),
    GET_generalNoteById: builder.query<IGeneralNote, {assignment_id: string, id: string}>({
      query: ({assignment_id, id}) => ({
        url: `/assignment-all-purpose-items/${assignment_id}/${id}/`,
      }),
      providesTags: ['general-notes'],
    }),
    POST_generalNote: builder.mutation<IGeneralNote, {assignment_id: string, body: IGeneralNoteData}>({
      query: ({assignment_id, body}) => ({
        url: `/assignment-all-purpose-items/${assignment_id}/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['general-notes','general-note'],
    }),
    PATCH_generalNote: builder.mutation<IGeneralNote, {assignment_id: string, id: string, body: IGeneralNoteData}>({
      query: ({assignment_id, id, body}) => ({
        url: `/assignment-all-purpose-items/${assignment_id}/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['general-notes','general-note'],
    }),
    DELETE_generalNote: builder.mutation<IGeneralNote, {assignment_id: string, id: string}>({
      query: ({assignment_id, id}) => ({
        url: `/assignment-all-purpose-items/${assignment_id}/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['general-notes'],
    }),
  }),
})

export const {
  useGET_generalNotesQuery,
  useGET_generalNoteByIdQuery,
  usePOST_generalNoteMutation,
  usePATCH_generalNoteMutation,
  useDELETE_generalNoteMutation,
} = GeneralNotesAPI
